import React from 'react';

function DropDownIcon() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.375 6.875C3.375 6.65 3.44953 6.5 3.5986 6.35C3.89674 6.05 4.34394 6.05 4.64208 6.35L9.41227 11.075L14.1079 6.35C14.4061 6.05 14.8533 6.05 15.1514 6.35C15.4495 6.65 15.4495 7.1 15.1514 7.4L9.93401 12.65C9.78494 12.8 9.63587 12.875 9.41227 12.875C9.18866 12.875 9.0396 12.8 8.89053 12.725L3.67314 7.475C3.44953 7.25 3.375 7.1 3.375 6.875Z"
        fill="#819E9F"
      />
    </svg>
  );
}

export default DropDownIcon;
